/**
 * Viewport utility functions.
 * All assigned to window so page-level templates can call them without importing.
 * $container is typically $(window) but can be any scrollable element.
 */

function isInViewport($this, $container) {
  if (!$this || $this.length === 0) return;
  const elementTop    = $this.offset().top;
  const elementBottom = elementTop + $this.outerHeight();
  const viewportTop   = $($container).scrollTop();
  const viewportBottom = viewportTop + window.iTheHeight;
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

function isBelowViewport($this, $container) {
  if (!$this || $this.length === 0) return;
  const elementTop     = $this.offset().top;
  const viewportBottom = $($container).scrollTop() + window.iTheHeight;
  return elementTop > viewportBottom;
}

function isAboveViewport($this, $container) {
  if (!$this || $this.length === 0) return;
  const elementBottom = $this.offset().top + $this.outerHeight();
  const viewportTop   = $($container).scrollTop();
  return elementBottom < viewportTop;
}

function isTopAboveViewportTop($this, $container) {
  if (!$this || $this.length === 0) return;
  const elementTop  = $this.offset().top;
  const viewportTop = $($container).scrollTop();
  return elementTop < viewportTop;
}

function isBottomAboveViewportTop($this, $container) {
  if (!$this || $this.length === 0) return;
  const elementBottom = $this.offset().top + $this.outerHeight();
  const viewportTop   = $($container).scrollTop();
  return elementBottom < viewportTop;
}

export function initViewportUtils() {
  window.isInViewport           = isInViewport;
  window.isBelowViewport        = isBelowViewport;
  window.isAboveViewport        = isAboveViewport;
  window.isTopAboveViewportTop  = isTopAboveViewportTop;
  window.isBottomAboveViewportTop = isBottomAboveViewportTop;
}



// WEBPACK FOOTER //
// ./scripts/utils/viewport.js